import * as React from "react";
const SvgFiRrUserMusic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-music_svg__a)">
      <path
        fill="#062147"
        d="M24 20.5v.004a2.5 2.5 0 1 1-2-2.45v-3.917a.99.99 0 0 0-.345-.755 1 1 0 0 0-.797-.235l-2.57.367A1.51 1.51 0 0 0 17 14.999v6.504a2.5 2.5 0 1 1-2-2.45v-4.054c0-1.73 1.292-3.22 3.005-3.465l2.571-.367A2.999 2.999 0 0 1 24 14.137zM2 6c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6m2 0c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4m8.927 9.957a1 1 0 0 0-.551-1.302A8.9 8.9 0 0 0 9.001 14C4.038 14 0 18.038 0 23a1 1 0 0 0 2 0 7.008 7.008 0 0 1 9.625-6.492 1 1 0 0 0 1.302-.551"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-music_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserMusic;
